export default {
	field_cannot_be_empty: "O campo não pode ser vazio",
	invalid_format_email: "Email é inválido",
	user_email_not_exist: "Usuário não cadastrado",
	user_email_exist: "Usuário já cadastrado no sistema",
	number_of_characters_less_than_six: "Deve conter mais de 6 caracteres",
	number_of_characters_less_than_three: "Deve conter mais de 3 caracteres",
	password_is_invalid: "Senha inválida",
	value_must_be_a_number: "Insira um número.",
	editable_text_already_exists: "Já existe um texto editável com este código.",
	instances_not_found: "Nenhuma das instâncias informadas foi encontrada.",
	instance_ids_required: "IDs das instâncias são obrigatórios.",
	instance_ids_invalid_format: "O formato da entrada dos IDs das instâncias é inválido. Deve ser uma lista apenas de números e separados por vírgula.",
	webhook_hash_required: "O URL ou HASH do webhook é obrigatório.",
	invalid_url_or_hash: "O URL ou HASH do webhook é inválido.",
	invalid_email: "Informe um e-mail válido.",
	email_already_used: "Já existe um administrador com este e-mail."
}
